import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function CardApproved({ baseUrl, onLoginSuccess, currentUser }) {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const payment_intent_id = searchParams.get("payment_intent_id");
        const agent_id = searchParams.get("agent_id");
        const payment_method = searchParams.get("payment_method");
        const charge_price = searchParams.get("charge_price");
        const call_duration = searchParams.get("call_duration");
        const call_id = searchParams.get("call_id");
        
        var formData = new FormData();

        formData.append("payment_intent_id", payment_intent_id);
        formData.append("agent_id", agent_id);
        formData.append("token", currentUser?.token);
        formData.append("payment_method", payment_method);
        formData.append("charge_price", charge_price);
        formData.append("call_duration", call_duration);
        formData.append("call_id", call_id);

        axios.post(baseUrl + "/confirmWebCallCard", formData)
        .then(response => {
            console.log("Login success:", response.data);
    
            const channel = new BroadcastChannel("chamcore-approve-payment");
            channel.postMessage({
                type: "CARD_PAYMENT_APPROVED",
                call_id: response.data.call_id,
            });
            channel.close();
    
            // Optionally close tab automatically
            setTimeout(() => window.close(), 1000);
        })
    }, [searchParams]);

    return (
        <div className="p-6 text-center">
            <h1 className="text-xl font-bold">Logg in godkjent</h1>
            <p>Takk for at du godkjenner Logg in.</p>
        </div>
    );
}
